import type { ButtonOptions } from '@viewup/ui';

export const weeks = ['일', '월', '화', '수', '목', '금', '토'];

export const buttonStyles: ButtonOptions['styledComponents'] = {
  root: {
    bgColor: 'bg.tertiary',
    br: 12,
    css: {
      '& > span': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
      height: 'max-content',
      width: '100%',
    },
    mt: 16,
    px: 16,
    py: 12,
  },
};
